<template>
  <div class="login-section pa-3 text-center">
    <div
      class="login-header"
      style="display: flex; justify-content: space-between; align-items: center;"
    >
      <span class="login-title">Autenticação</span>
      <v-icon @click="$emit('onCancel')" color="black">close</v-icon>
    </div>

    <p class="mb-2 normal-text">
      Insira abaixo o token que enviamos para seu email
    </p>

    <v-text-field
      v-model="token"
      label="Token"
      outline
      dense
      class="mx-auto mt-4"
      style="max-width: 200px"
    ></v-text-field>

    <div class="mt-3 d-flex justify-center">
      <v-btn
        block
        round
        outline
        depressed
        color="primary"
        :loading="resendLoading"
        class="mr-2 normal-text"
        @click="handleResendEmail"
      >
        Reenviar Email
      </v-btn>
      <v-btn
        block
        round
        depressed
        class="mr-2 normal-text"
        color="primary"
        :loading="loading"
        :disabled="!token"
        @click="handleVerifyToken"
      >
        Verificar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['login'],

  data() {
    return {
      token: '',
      resendLoading: false,
      loading: false,
    };
  },

  methods: {
    async handleVerifyToken() {
      this.$emit('login', this.token);
    },
    async handleResendEmail() {
      try {
        this.resendLoading = true;

        const params = {
          email: this.login.email,
        };

        const resp = await this.$store.dispatch(
          'REQ_RESEND_LOGIN_TOKEN',
          params
        );

        if (resp.status === 200) {
          this.$store.dispatch('openSnackbar', {
            message: 'Token enviado para o email.',
            color: 'success',
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.resendLoading = false;
      }
    },
  },
};
</script>

<style>
.login-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
}
</style>
